import React, { useState, useEffect } from 'react';
import { blogAPI } from '../../services/api';
import { getImgUrl } from '../../utils/config';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdminBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await blogAPI.getAll();
            setBlogs(response.data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this blog?')) {
            try {
                await blogAPI.delete(id);
                fetchBlogs();
            } catch (error) {
                console.error("Error deleting blog:", error);
                alert("Failed to delete blog");
            }
        }
    };

    return (
        <div className="pt-24 min-h-screen bg-gray-100 px-6 pb-12">
            <div className="container mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold text-gray-800">Blog Management</h1>
                    <Link
                        to="/admin/blogs/add"
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 shadow-md transition-colors"
                    >
                        <Plus size={20} />
                        <span>Add Blog</span>
                    </Link>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Media</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {loading ? (
                                <tr><td colSpan="5" className="px-6 py-4 text-center">Loading...</td></tr>
                            ) : blogs.length === 0 ? (
                                <tr><td colSpan="5" className="px-6 py-4 text-center">No blogs found.</td></tr>
                            ) : (
                                blogs.map((blog) => (
                                    <tr key={blog.id} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="h-10 w-10 flex-shrink-0 bg-gray-100 rounded-md overflow-hidden">
                                                {blog.media_url ? (
                                                    blog.media_type === 'video' ? (
                                                        <video src={getImgUrl(blog.media_url)} className="h-full w-full object-cover" />
                                                    ) : (
                                                        <img src={getImgUrl(blog.media_url)} alt="" className="h-full w-full object-cover" />
                                                    )
                                                ) : (
                                                    <div className="h-full w-full flex items-center justify-center text-gray-400">📝</div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900 truncate max-w-xs">{blog.title}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${blog.media_type === 'video' ? 'bg-purple-100 text-purple-800' :
                                                blog.media_type === 'image' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
                                                }`}>
                                                {blog.media_type}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {new Date(blog.createdAt).toLocaleDateString()}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <Link to={`/admin/blogs/edit/${blog.id}`} className="text-indigo-600 hover:text-indigo-900 mr-4 inline-block">
                                                <Edit size={18} />
                                            </Link>
                                            <button onClick={() => handleDelete(blog.id)} className="text-red-600 hover:text-red-900">
                                                <Trash2 size={18} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminBlogs;
